export const isIOS = () => {
  return getMobileOperatingSystem() === 'iOS';
};

export const isAndroid = () => {
  return getMobileOperatingSystem() === 'Android';
};

const getMobileOperatingSystem = () => {
  const Window = window as any;
  const userAgent = navigator.userAgent || navigator.vendor || Window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection is from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !Window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
